import { render, staticRenderFns } from "./fib_extension_tool.vue?vue&type=template&id=63df53a2"
import script from "./fib_extension_tool.vue?vue&type=script&lang=js"
export * from "./fib_extension_tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports